import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decodeSeoUri',
    standalone: false
})
export class DecodeSeoUriPipe implements PipeTransform {
    transform(uri: string): string {
        if (uri === undefined) return '';
        return uri.replace(/-/g, ' ');
    }
}
